import { mapGetters } from 'vuex';
import CartItemControls from '@/modules/cart/CartItemControls';

export default {
  props: {
    orderType: {
      type: Object,
    },
  },
  data() {
    return { cartItemControls: null };
  },
  created() {
    this.cartItemControls = new CartItemControls({
      cartRequestVuexGetter: () => this.cart,
      nonEmptyCartVuexGetter: () => this.nonEmptyCarts,
      lineItemsVuexGetter: () => this.getLineItems,
      giftCardLineItemsVuexGetter: () => this.getGiftCardItems,
      customerModeScanStateVuexGetter: () => this.isCustomerModeScan,
      orderTypePropGetter: () => this.orderType,
    });
  },
  computed: {
    ...mapGetters({
      cart: 'cart/getCartSyncDto',
      nonEmptyCarts: 'cart/nonEmptyCarts',
      getLineItems: 'cart/getLineItems',
      getGiftCardItems: 'cart/getGiftCardItems',
      isCustomerModeScan: 'user/isCustomerModeScan',
    }),
    cartLineItems() {
      if (!this.cartItemControls) return [];
      return this.cartItemControls.getCartLineItems();
    },
    isEmpty() {
      return this.cartItemControls.isEmpty();
    },
  },
  methods: {
    /**
     * The line item for the requested inventory item
     */
    getItemLineItem(item, variation = null) {
      return this.cartItemControls.getItemLineItem(item, variation);
    },
    getLineItemsOfType(type) {
      return this.cartItemControls.getLineItemsOfType(type);
    },
    lineItemCount(cart) {
      return this.cartItemControls.getLineItemCount(cart);
    },
    specialOrderItemLineItemCount(cart) {
      return this.cartItemControls.getSpecialOrderItemLineItemCount(cart);
    },
    cartLineItemCount(orderTypeCart) {
      return this.cartItemControls.getCartLineItemCount(orderTypeCart);
    },
  },
};
